
function Footer(props) {
    return (
        <>
            <div className="card fixed-bottom text-center " style={{
                backgroundColor: props.mode === 'dark' ? '#212529' : 'white',
                color: props.mode === 'dark' ? 'white' : 'black'
            }}>
                <div className="card-body ">
                    <h5 className="card-title">Made with ❤ by Haris Malik</h5>
                    <p className="card-text">If you found this app helpful, you can support me by following me on Instagram <a className="fw-bold"  href="https://www.instagram.com/malik_haris_1/" >@malik_haris_1</a> </p>
                </div>
            </div>
        </>
    )
}

export default Footer